import type { Socket } from "socket.io-client";

export enum SOCKET_IO_EVENT {
  CONNECT = "connect",
  DISCONNECT = "disconnect",
}

// Copy pasted from v1
// TODO: Remove unused
export enum SOCKET_EVENT {
  REGISTER_USER = "register-user",
  UNREGISTER_USER = "unregister-user",
  REMOVE_USER_DEVICE = "remove-user-device",
  JOIN_USER_ROOM = "join-user-room",
  LEAVE_USER_ROOM = "leave-user-room",
  JOIN_EVENT_ROOM = "join-event-room",
  LEAVE_EVENT_ROOM = "leave-event-room",
  EVENT_URL_CHANGE = "event-url-change",
  COMMENT_ON_MEDIA = "comment-on-media",
  COMMENT_ON_MEDIA_DELETED = "comment-on-media-deleted",
  COMMENT_ON_MEDIA_UPDATED = "comment-on-media-updated",
  UPDATE_EVENT = "update-event",
  USER_PURCHASE_STATUS = "user-purchase-status",
}

/**
 * Socket.IO composable (SSR-safe)
 *
 * Accesses the Socket.IO instance from the client-only plugin.
 * Returns null on server-side.
 *
 * @returns Socket instance on client, null on server
 * @example
 * ```typescript
 * const socket = useSocketIO();
 * if (socket) {
 *   socket.emit('event', data);
 * }
 * ```
 */
export default function useSocketIO(): Socket | null {
  const nuxtApp = useNuxtApp();
  return (nuxtApp.$socket as Socket) || null;
}
